<script>
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import Button from '@/components/Button'
import DropdownSelect from '@/components/DropdownSelect'
import AccountPreview from '@/components/AccountPreview'
import StringUtils from '@/utils/stringUtils'
import EnvironmentUtils from '@/utils/environmentUtils'
import AvatarUtils from '@/utils/avatarUtils'
import AccountsServices from '@/services/accounts'

const STEPS =
{
    createAccount: 0,
    accountCreated: 1
}

export default
{
    name: 'create-account',

    props:
    {
        title: {type: String, default: 'Créer un compte 📦'},
        successBtnText: {type: String, default: 'Continuer'},
        successBtnAction: {type: Function, default: () => app.$router.back()},
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='create-account'>
                <div class='create-account-form' v-show={this.step == STEPS.createAccount}>
                    <div class='title' v-show={this.title}>{this.title}</div>
                    <div class='fields'>
                        <FloatingLabelTextInput ref='lastName' v-model={this.lastName} placeholder='Nom' />
                        <FloatingLabelTextInput ref='firstName' v-model={this.firstName} placeholder='Prénom' />
                        <DropdownSelect ref='gender' v-model={this.gender} label='Genre' options={this.genderOptions} />
                        <FloatingLabelTextInput ref='username' v-model={this.username} placeholder="Nom d'utilisateur" />
                        <FloatingLabelTextInput ref='email' v-model={this.email} type='email' placeholder='Courriel' />
                        <FloatingLabelTextInput ref='password' v-model={this.password} type='password' placeholder='Mot de passe' />
                        <Button on-click={this.onCreateAccountClicked} text='Créer ce compte' />
                        <Button on-click={() => this.$router.push('/settings/login')} text="J'ai déjà un compte, me connecter" type='text'
                            class = 'login-btn' />
                    </div>
                </div>

                <div class='account-created' v-show={this.step == STEPS.accountCreated}>
                    <account-preview user={{lastName: this.lastName, firstName: this.firstName,
                        profilePictureUrl: this.profilePictureUrl, username: this.username}} />
                    <div class='title'>{EnvironmentUtils.clientName} vous souhaite la bienvenue !</div>
                    <Button text={this.successBtnText} on-click={this.successBtnAction} />
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            step: 0,
            lastName: '',
            firstName: '',
            gender: '',
            username: '',
            email: '',
            password: '',
            profilePictureUrl: AvatarUtils.generateRandomAvatarUrl(Number.parseInt(Math.random() * 10000000)),
            genderOptions: { female: 'Féminin', male: 'Masculin', other: 'Autre' }
        }
    },

    computed:
    {
    },

    methods:
    {
        async onCreateAccountClicked (event, button)
        {
            button.showSpinner = true

            const isValid = this.checkFieldsValidity()
            if (isValid)
            {
                const accountData =
                {
                    lastName: this.lastName,
                    firstName: this.firstName,
                    isFemale: this.genderOptions[this.gender] == this.genderOptions.female,
                    username: this.username,
                    email: this.email,
                    password: this.password,
                    profilePictureUrl: this.profilePictureUrl,
                    belongsToCityId: EnvironmentUtils.cityId
                }

                try
                {
                    const createdAccount = await AccountsServices.createAccount(accountData)
                    console.log('Account', createdAccount, 'created')
                    
                    this.step = STEPS.accountCreated
                    this.$emit('account-created', createdAccount)

                }
                catch (error)
                {
                    console.log('Account creation', accountData, 'failed')
                }
            }

            button.showSpinner = false
        },

        checkFieldsValidity ()
        {
            let isValid = true

            if (StringUtils.isEmptyString(this.lastName))
            {
                this.$refs.lastName.setErrorMessage('Vous devez donner un nom')
                isValid = false
            }
            if (StringUtils.isEmptyString(this.firstName))
            {
                this.$refs.firstName.setErrorMessage('Vous devez donner un prénom')
                isValid = false
            }
            if (StringUtils.isEmptyString(this.gender))
            {
                this.$refs.gender.setErrorMessage('De quel genre est le propriétaire ?')
                isValid = false
            }
            if (StringUtils.isEmptyString(this.username))
            {
                this.$refs.username.setErrorMessage('Un pseudo est nécessaire')
                isValid = false
            }
            if (StringUtils.isEmptyString(this.email))
            {
                this.$refs.email.setErrorMessage('Vous devez fournir un courriel, aucun spam garanti :)')
                isValid = false
            }
            if (StringUtils.isEmptyString(this.password))
            {
                this.$refs.password.setErrorMessage('Oups vous alliez oublier le mot de passe !')
                isValid = false
            }

            return isValid
        }
    },

    components:
    {
        FloatingLabelTextInput,
        Button,
        DropdownSelect,
        AccountPreview
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.create-account
{
    display: flex;
    justify-content: center;

    .create-account-form
    {
        width: -webkit-fill-available;
        padding: 6%;
        border-radius: 6px;
        background-color: var(--theme-content-background-color);
        box-shadow: var(--theme-box-shadow-sharp);

        .OnDesktop({
            padding: 25px 0%;
        });

        .title
        {
            font-size: 25px;
            margin-bottom: 12%;
            text-align: center;
            font-weight: 700;

            .OnLarge({
                margin-bottom: 9%;
            });
        }

        .fields
        {
            .OnDesktop({ margin: 0 6%; });

            .floating-label-text-input
            {
                &:first-of-type
                {
                    margin-top: 0;
                }

                margin-top: 20px;
            }

            .dropdown-select
            {
                margin-top: 20px;
            }

            .button
            {
                width: 100%;
                margin-top: 4vh;

                &.login-btn
                {
                    margin-top: 15px;
                }
            }
        }
    }

    .account-created
    {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        background-color: var(--theme-content-background-color);
        width: -webkit-fill-available;
        padding: 3vh 4vw;
        margin-top: 100px;
        border-radius: 7px;
        box-shadow: var(--theme-box-shadow-soft);

        .image
        {
            width: 45%;

            .OnTablet({ width: 35%; });
            .OnDesktop({ .WidthHeight(10vw); });
            .OnLarge({ .WidthHeight(8vw); });
        }

        .title
        {
            .CapitalizeFirstLetter();
            font-size: 25px;
            font-weight: bold;
            font-family: Nunito;
            color: var(--theme-text-color-light);
            text-align: center;
            margin-top: 30px;
        }

        .button
        {
            margin-top: 40px;
            width: 100%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/CreateAccount.vue